const base = {}
base.byD = function(name, minor) {
	return function(o, p) {
		var a, b;
		if (typeof o === "object" && typeof p === "object" && o && p) {
			a = o[name];
			b = p[name];
			if (a === b) {
				return typeof minor === 'function' ? minor(o, p) : 0;
			}
			if (typeof a === typeof b) {
				return a > b ? -1 : 1;
			}
			return typeof a > typeof b ? -1 : 1;
		} else {
			throw ("error");
		}
	}
}
base.getUrlParam = function(name) {
	// var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); //构造一个含有目标参数的正则表达式对象

	var r = window.location.href.split('?')[1]; //匹配目标参数
	if (r != null) return r.split('&')[0].split('=');
	return null; //返回参数值
}
base.GetUrlParam = function(paraName) {
		//微信回调 回回调当前请求的域名 所以需要从链接后获取参数
		var url = document.location.toString();
		console.log(url)
		var arrObj = url.split("?");
		if (arrObj.length > 1) {
			var arrPara = arrObj[1].split("&");
			var arr;
			for (var i = 0; i < arrPara.length; i++) {
				arr = arrPara[i].split("=");
				if (arr != null && arr[0] == paraName) {
					return arr[1];
				}
			}
			return "";
		} else {
			return "";
		}
	},
	//LocalStorage保存
	base.setLS = function(name, value) {
		localStorage.setItem(name, value)
		// localStorage[name] = value;
	}

base.query = function(arr, q) {
	return arr.filter(v => Object.values(v).some(v => new RegExp(q + '').test(v)))
}
base.getCurrentDateTimeSeconds = function() {
	// 当前毫秒的时间戳
	return Math.round(new Date().getTime() / 1000);
}
base.getDateTime = function() { // 获取当前日期
	var date = new Date();
	var str = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate()
	return str;
}
base.isWeixin = function() {//判断是否是微信浏览器
	let ua = navigator.userAgent.toLowerCase();
	if (ua.match(/MicroMessenger/i) == "micromessenger") {
		return true
	} else {
		return false
	}
}
 base.choicelessCoupons=function(couponsDataList, sessionMoney) {//小于充值金额并且最接近充值金额的
    sessionMoney = parseFloat(sessionMoney / 100);//先把传来的金额进行数值转换
    let minMoney = [];//存放小于场地费用最接近的数
    let couponsId = 0;//获取最接近的key
    var arrId=[]
    for (let i = 0; i < couponsDataList.length; i++) {
      let couponsItem = couponsDataList[i];
      couponsItem.fullMoney = parseFloat(couponsItem.fullMoney);	//先进行浮点型数值转换
      //如果等于就是最接近
      if (couponsItem.fullMoney <= sessionMoney) { //如果小于场地金额
        minMoney.push(parseFloat(couponsDataList[i].reduceMoney))
        arrId.push({id:couponsDataList[i].id,reduceMoney:couponsDataList[i].reduceMoney})
      }
    }
    let jiejin = 0;
    console.log('最接近优惠券的数：', '小于', minMoney);
    //获取最近进的数
    if (minMoney.length > 0) {
      jiejin = Math.max.apply(null, minMoney);
    }
    console.log('接近：', jiejin);
    //用获取最接近的数对数组进行循环获取Key
    if (0 != jiejin) {
      for (let i = 0; i < arrId.length; i++) {
        if (jiejin == parseFloat(arrId[i].reduceMoney)) {
          couponsId = arrId[i].id;
        }
      }
    }
    console.log('满减金额', couponsId)
    // 满减金额最大的
    return couponsId;//返回数组key
  }
  base.choicegreaterCoupons=function(couponsDataList, sessionMoney) {//大于充值金额并且最接近充值金额的
    sessionMoney = parseFloat(sessionMoney / 100);//先把传来的金额进行数值转换
    let maxMoney = [];//存放大于场地费用最接近的数
    let couponsId = 0;//获取最接近的key
    for (let i = 0; i < couponsDataList.length; i++) {
      let couponsItem = couponsDataList[i];
      couponsItem.fullMoney = parseFloat(couponsItem.fullMoney);	//先进行浮点型数值转换
      if (couponsItem.fullMoney > sessionMoney) { //如果大于场地金额
        maxMoney.push(parseFloat(couponsDataList[i].fullMoney));
      }
    }
    let jiejin = 0;
    console.log('最接近优惠券的数：', '小于：', maxMoney);
    //获取最近进的数
    if (maxMoney.length > 0) {
      jiejin = Math.min.apply(null, maxMoney);
    }
    console.log('接近：', jiejin);
    //用获取最接近的数对数组进行循环获取Key
    if (0 != jiejin) {
      for (let i = 0; i < couponsDataList.length; i++) {
        if (jiejin == parseFloat(couponsDataList[i].fullMoney)) {
          couponsId = couponsDataList[i].id;
        }
      }
    }
    console.log('差多少元', couponsId)
    // 差多少元可以减
    return couponsId;//返回数组key
  }
   base.getTimeMiute=function(time){
      return time.split(':')[0]+':'+time.split(':')[1]
    }
    base.setStorage =function (key,value){
     return localStorage.setItem(key, value)
    }
    base.getStorage =function (key){
      return localStorage.getItem(key)
     }
     base.removeStorage =function (key){
      return localStorage.removeItem(key)
     }





//写数据
base.localStorageSet = (name, data, expire = 24) => {
  const time = new Date().getTime() + expire * 60 * 60 * 1000;
  const obj = { data, time };
  localStorage.setItem(name, JSON.stringify(obj));
}
base.localStorageGet = name => {
  const storage = localStorage.getItem(name);
  const time = new Date().getTime();
  let result = {};
  if (storage) {
    const obj = JSON.parse(storage);
    if (time < obj.time) {
      result = obj.data;
    } else {
      localStorage.removeItem(name);
    }
  }
  return result;
}























export default base;



// WEBPACK FOOTER //
// ./src/common/base.js